import { Col, Row, Label, PrimaryButton, InputField, ReactSelectBox, ModalPopup, OutlineButton } from 'client/CommonComponents';
import { isAlphaNumeric, isNumber } from "utils";
import { MaskedTextField } from "@fluentui/react"
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';
import DealerVendorListContent from '../DealerVendorListContent';
import permissions, { isAuthorized } from 'client/utils/Permissions';


const NonStandardEquipment = (props: any) => {

  const orderDetails = props.orderDetails;
  const yearDropdownList = props.yearDropdownList;
  const usedDropdownList = props.usedDropdownList
  const vendorDropdownList = props.vendorDropdownList
  const nonStandardEquipmentValidation = props.nonStandardEquipmentValidation
  const popupContent = props.popupContent
  const hideDialog = props.hideDialog
  const onChangeMake = props.onChangeMake
  const onChangeModel = props.onChangeModel
  const onChangeYear = props.onChangeYear
  const onChangeIsUsed = props.onChangeIsUsed
  const onChangeVinSerial = props.onChangeVinSerial
  const onChangePricePerUnit = props.onChangePricePerUnit
  const onChangeDescription = props.onChangeDescription
  const onChangeVendorName = props.onChangeVendorName
  const onChangeDealerContact = props.onChangeDealerContact
  const onChangeDealerPhone = props.onChangeDealerPhone
  const onChangeEmailAddress = props.onChangeEmailAddress
  const onChangeAddress1 = props.onChangeAddress1
  const onChangeAddress2 = props.onChangeAddress2
  const onChangeAddress3 = props.onChangeAddress3
  const onChangeCity = props.onChangeCity
  const onChangeState = props.onChangeState
  const onChangeZip = props.onChangeZip
  const unitPriceFormat = props.unitPriceFormat
  const filterOptionVendor = props.filterOptionVendor;
  const dealerVendorPopupClick = props.dealerVendorPopupClick;
  const showDealerVendorPopup = props.showDealerVendorPopup;
  const setShowDealerVendorPopup = props.setShowDealerVendorPopup;
  const vendorSearchText = props.vendorSearchText
  const dealerSelectOnBlur = props.dealerSelectOnBlur
  const vendor = props.vendor
  const updateOnClick =props.updateOnClick
  const isEditRequestClick = props.isEditRequestClick
  const cancelEditRequestType = props.cancelEditRequestType

  return <div className='non-standard-equipment p-3'>
    <Row>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-0 mb-2'>
        <Label required data-attribute="NonStandardEquipment_Default_Label">Make</Label>
        <InputField
          placeholder='Enter Make'
          value={orderDetails.make}
          name='make'
          onChange={(item: any) => onChangeMake(item)}
          inputRef={(element:any) => props.NonStandardRef.current[0] = element}
          className={nonStandardEquipmentValidation.makeError.length > 0 ? 'controlValidation' : ''}
         data-attribute="NonStandardEquipment_make_Input" />
        {nonStandardEquipmentValidation.makeError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.makeError}</p> : null}
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
        <Label required data-attribute="NonStandardEquipment_Default_Label_2">Model #</Label>
        <InputField
          placeholder='Enter Model No.'
          value={orderDetails.model}
          name={'model'}
          onChange={(item: any) => onChangeModel(item)}
          onKeyPress={(event: any) => { isAlphaNumeric(event) }}
          className={nonStandardEquipmentValidation.modelError.length > 0 ? 'controlValidation' : ''}
         data-attribute="NonStandardEquipment_model_Input" />
        {nonStandardEquipmentValidation.modelError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.modelError}</p> : null}
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
        <Label required data-attribute="NonStandardEquipment_Default_Label_3">Year</Label>
        <ReactSelectBox
          options={yearDropdownList}
          onChange={(item: any) => onChangeYear(item)}
          value={orderDetails.year}
          className={nonStandardEquipmentValidation.yearError.length > 0 ? 'controlValidation' : ''}
         data-attribute="NonStandardEquipment_Default_SearchSelectBox" />
        {nonStandardEquipmentValidation.yearError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.yearError}</p> : null}
      </Col>

      <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mb-md-0 mb-2'>
        <Label required data-attribute="NonStandardEquipment_Default_Label_4">Used</Label>
        <ReactSelectBox
          options={usedDropdownList}
          onChange={(item: any) => onChangeIsUsed(item)}
          value={orderDetails.isUsed}
          className={nonStandardEquipmentValidation.isUsedError.length > 0 ? 'controlValidation' : ''}
         data-attribute="NonStandardEquipment_Default_SearchSelectBox_2" />
        {nonStandardEquipmentValidation.isUsedError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.isUsedError}</p> : null}
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mb-md-0 mb-2'>
        <Label data-attribute="NonStandardEquipment_Default_Label_5">VIN/Serial #</Label>
        <InputField
          placeholder='Enter VIN/Serial No.'
          value={orderDetails.vinSerial}
          name={'vinSerial'}
          onKeyPress={(event: any) => { isAlphaNumeric(event) }}
          onChange={(item: any) => onChangeVinSerial(item)}
          onBlur={(e: any) => props.onBlurVinSerial(e.target.value)}
          className={nonStandardEquipmentValidation.vinSerialError.length > 0 ? 'controlValidation' : ''}
         data-attribute="NonStandardEquipment_vinSerial_Input" />
        {nonStandardEquipmentValidation.vinSerialError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.vinSerialError}</p> : null}
        {props.vinValidationMessage && nonStandardEquipmentValidation.vinSerialError.length === 0 && <p className='validMessage'>{props.vinValidationMessage}</p>}
      </Col>

      <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mb-md-0 mb-2'>
        <Label required data-attribute="NonStandardEquipment_Default_Label_6">Unit Price $</Label>
        <InputField
          placeholder="0.00"
          onBlur={(event: any) => unitPriceFormat(event)}
          name="pricePerUnit"
          prefix={"$"}
          value={orderDetails.pricePerUnit ? orderDetails.pricePerUnit : ''}
          onChange={(item: any) =>{onChangePricePerUnit(item);isNumber(item);} }
          //onKeyPress={(event: any) => { isNumber(event) }}
          className={nonStandardEquipmentValidation.pricePerUnitError.length > 0 ? 'controlValidation' : ''}
         data-attribute="NonStandardEquipment_pricePerUnit_Input" />
        {nonStandardEquipmentValidation.pricePerUnitError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.pricePerUnitError}</p> : null}
      </Col>
      <Col xs={12} sm={12} md={12} lg={12} className='mt-2 mb-md-0 mb-2'>
        <Label data-attribute="NonStandardEquipment_Default_Label_7">Description</Label>
        <InputField
          placeholder='Enter Description'
          name={'description'}
          value={orderDetails.description}
          onChange={(item: any) => onChangeDescription(item)}
          multiline={true}
          resizable={false}
          row={3}
          className={nonStandardEquipmentValidation.descriptionError.length > 0 ? 'controlValidation comment-block' : 'comment-block'}
         data-attribute="NonStandardEquipment_description_Input" />
        {nonStandardEquipmentValidation.descriptionError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.descriptionError}</p> : null}
      </Col>
    </Row>
    <div className='mt-3 p-3'>
      <p className='vendorHeading'>Dealer Detail</p>
      <Row>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-md-0 mb-2'>
        <div className="dealer-name"><Label required data-attribute="NonStandardEquipment_Default_Label_9">Dealer Name</Label><a href='/' className='dealer-list' onClick={dealerVendorPopupClick}>Dealer/Vendor not listed?</a></div>
          <ReactSelectBox
            options={vendorDropdownList}
            onChange={(item: any) => onChangeVendorName(item)}
            value={vendor || ""}
            name={orderDetails?.vendorName}
            isSearchable={true}
            inputValue={vendorSearchText}
            onInputChange={(value: any, action: any) => filterOptionVendor(value, action)}
            className={nonStandardEquipmentValidation.vendorNameError.length > 0 ? 'controlValidation' : ''}
            onBlur={dealerSelectOnBlur}
           data-attribute="NonStandardEquipment_Default_SearchSelectBox_3" />
          {nonStandardEquipmentValidation.vendorNameError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.vendorNameError}</p> : null}
        </Col>

        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
          <Label required data-attribute="NonStandardEquipment_Default_Label_10">Dealer Contact</Label>
          <InputField
            placeholder='Enter Dealer Contact'
            name={'dealerContact'}
            value={orderDetails.dealerContact}
            onChange={(item: any) => onChangeDealerContact(item)}
            className={nonStandardEquipmentValidation?.dealerContactError?.length > 0 ? 'controlValidation' : ''}
           data-attribute="NonStandardEquipment_dealerContact_Input" />
          {nonStandardEquipmentValidation?.dealerContactError?.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.dealerContactError}</p> : null}
        </Col>

        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
          <Label required data-attribute="NonStandardEquipment_Default_Label_11">Dealer Phone</Label>
          <MaskedTextField
            name="dealerPhone"
            value={orderDetails.dealerPhone}
            placeholder="123-456-7890"
            mask="999-999-9999"
            onChange={(item: any) => onChangeDealerPhone(item)}
            className={nonStandardEquipmentValidation.dealerPhoneError.length > 0 ? 'controlValidation form-input' : 'form-input'}
          />
          {nonStandardEquipmentValidation.dealerPhoneError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.dealerPhoneError}</p> : null}
        </Col>

        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mb-md-0 mb-2'>
          <Label required data-attribute="NonStandardEquipment_Default_Label_12">Email Address</Label>
          <InputField
            placeholder='Enter Email Addresss'
            name={'emailAddress'}
            value={orderDetails.emailAddress}
            onChange={(item: any) => onChangeEmailAddress(item)}
            className={nonStandardEquipmentValidation?.emailAddressError?.length > 0 ? 'controlValidation' : ''}
           data-attribute="NonStandardEquipment_emailAddress_Input" />
          {nonStandardEquipmentValidation?.emailAddressError?.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.emailAddressError}</p> : null}
        </Col>

        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mb-md-0 mb-2'>
          <Label required data-attribute="NonStandardEquipment_Default_Label_13">Address 1</Label>
          <InputField
            placeholder='Enter Address 1'
            name={'address1'}
            value={orderDetails.address1}
            onChange={(item: any) => onChangeAddress1(item)}
            className={nonStandardEquipmentValidation.address1Error.length > 0 ? 'controlValidation' : ''}
           data-attribute="NonStandardEquipment_address1_Input" />
          {nonStandardEquipmentValidation.address1Error.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.address1Error}</p> : null}
        </Col>

        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mb-md-0 mb-2'>
          <Label data-attribute="NonStandardEquipment_Default_Label_14">Address 2</Label>
          <InputField
            placeholder='Enter Address 2'
            name={'address2'}
            value={orderDetails.address2}
            onChange={(item: any) => onChangeAddress2(item)}
            className={nonStandardEquipmentValidation.address2Error.length > 0 ? 'controlValidation' : ''}
           data-attribute="NonStandardEquipment_address2_Input" />
          {nonStandardEquipmentValidation.address2Error.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.address2Error}</p> : null}
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mb-md-0 mb-2'>
          <Label data-attribute="NonStandardEquipment_Default_Label_15">Address 3</Label>
          <InputField
            placeholder='Enter Address 3'
            name={'address3'}
            value={orderDetails.address3}
            onChange={(item: any) => onChangeAddress3(item)}
            className={nonStandardEquipmentValidation.address3Error.length > 0 ? 'controlValidation' : ''}
           data-attribute="NonStandardEquipment_address3_Input" />
          {nonStandardEquipmentValidation.address3Error.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.address3Error}</p> : null}
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mb-md-0 mb-2'>
          <Label required data-attribute="NonStandardEquipment_Default_Label_16">City</Label>
          <InputField
            placeholder='Enter City'
            name={'city'}
            value={orderDetails.city}
            onChange={(item: any) => onChangeCity(item)}
            className={nonStandardEquipmentValidation.cityError.length > 0 ? 'controlValidation' : ''}
           data-attribute="NonStandardEquipment_city_Input" />
          {nonStandardEquipmentValidation.cityError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.cityError}</p> : null}
        </Col>

        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mb-md-0 mb-2'>
          <Label required data-attribute="NonStandardEquipment_Default_Label_17">State</Label>
          <InputField
            placeholder='Enter State'
            name={'state'}
            value={orderDetails.state}
            onChange={(item: any) => onChangeState(item)}
            className={nonStandardEquipmentValidation.stateError.length > 0 ? 'controlValidation' : ''}
           data-attribute="NonStandardEquipment_state_Input" />
          {nonStandardEquipmentValidation.stateError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.stateError}</p> : null}
        </Col>

        <Col xs={8} sm={4} md={4} lg={4} className={`mt-2 mb-md-0 mb-2 ${!isEditRequestClick ? '' :'edit-width'}`}>
          <Label required data-attribute="NonStandardEquipment_Default_Label_18">Zip</Label>
          <InputField
            placeholder='Enter Zip'
            name={'zip'}
            value={orderDetails.zip ? orderDetails.zip : ''}
            onChange={(item: any) => onChangeZip(item)}
            onKeyPress={(event: any) => { isNumber(event) }}
            className={nonStandardEquipmentValidation.zipError.length > 0 ? 'controlValidation' : ''}
           data-attribute="NonStandardEquipment_zip_Input" />
          {nonStandardEquipmentValidation.zipError.length > 0 ? <p className='validMessage'>{nonStandardEquipmentValidation.zipError}</p> : null}
        </Col>

        <Col xs={4} sm={8} md={8} lg={8} className={`mt-0 ${!isEditRequestClick ? '' :'edit-width'}`}>
          <div className='pull-right rightAdd'>
          {!isEditRequestClick ? <PrimaryButton text='Add Item' onClick={props.addOnClick} data-attribute="NonStandardEquipment_Default_Button"></PrimaryButton>
            :<div className='editTypeBtnBlock'> <PrimaryButton text='Update Request' onClick={updateOnClick} className='me-2' disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="NonStandardEquipment_Default_Button_2"></PrimaryButton>   
            <OutlineButton text='Cancel Request' onClick={cancelEditRequestType} className='me-0' disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)}  data-attribute="NonStandardEquipment_Default_Button_3" /></div>}
          </div>
        </Col>
      </Row>
    </div>
    {popupContent.isDialogVisible && 
      <CancelConfirmationPopup
        hideDialog={!popupContent.isDialogVisible}
        onDismiss={hideDialog}
        Popupcontent={popupContent}
        popupOutlinebtnOnclick={() => popupContent.popupOutlinebtnOnclick()}
        popupPrimarybtnOnclick={() => popupContent.popupPrimarybtnOnclick()}
      />
    }
    {
      showDealerVendorPopup && 
      <ModalPopup
        ShowModalPopupFooter={false}
        ModalPopupTitle="Dealer/Vendor not listed?"
        ModalPopupType="medium"
        closeModalPopup={() => setShowDealerVendorPopup(false)}
        ModalPopupName='Dealer-Vendor-Popup'
       data-attribute="NonStandardEquipment_Default_ModalPopup">
          <DealerVendorListContent/>
      </ModalPopup>
    }
  </div>
};

export default NonStandardEquipment;